import { IApplicationState } from '../../../types/types';

export const getNoBoardsLoaded = (
    state: IApplicationState,
): boolean => {
    const dashboards = state.model && state.model.dashboards;
    if (!dashboards) return false;
    return !Object.keys(dashboards).length;
};
